import moment from 'moment';
import PropTypes from 'prop-types';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

import './styles.css';

const getValidTime = (time) => {
  if (!time) return null;
  if (typeof time === 'string' && moment(time).isValid()) {
    return moment(time);
  }
  if (typeof time === 'object' && moment.isMoment(time)) {
    return time;
  }
  return null;
};

const StyledTimePicker = (props) => {
  const { value, disabled, hasError } = props;

  const validValue = getValidTime(value);
  const MUIInputContainerStyles = `rc-time-picker-container ${
    disabled ? `rc-time-picker-disabled` : ``
  } ${hasError ? `rc-time-picker-has-error` : ``}`;
  return (
    <TimePicker
      className={MUIInputContainerStyles}
      {...props}
      value={validValue}
    />
  );
};

StyledTimePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
};

export default StyledTimePicker;
